import '../api/axios-client'

import { Outlet, createRootRoute } from '@tanstack/react-router'

import { AuthGuard } from '@/components/auth-guard'
import { Toaster } from '@/components/ui/sonner'
import ErrorPage from '@/global-error'
import NotFoundPage from '@/global-not-found'
import { Providers } from '@/providers'

const RootLayout = () => {
  return (
    <Providers>
      <AuthGuard>
        <Outlet />
      </AuthGuard>
      <Toaster />
    </Providers>
  )
}

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: ErrorPage,
  notFoundComponent: NotFoundPage,
})
